import { SxProps, Theme } from '@mui/system';
import TextField from '@mui/material/TextField';
import { useTranslations } from 'hooks/useTranslations';
import { useFormikInputProps } from 'utils/ui/formik';

type Props = {
  sx?: SxProps<Theme>;
};

export function SenderNameField(props: Props) {
  const { sx } = props;
  const { value, hasError, helperText, fieldProps } = useFormikInputProps('senderName');
  const translations = useTranslations();

  return (
    <TextField
      {...fieldProps}
      value={value || ''}
      fullWidth
      label={translations.support.senderHint()}
      helperText={helperText}
      error={hasError}
      size="small"
      sx={sx}
    />
  );
}
